interface WarningCycleIconProps {
  className?: string
}

export const WarningCycleIcon: React.FC<WarningCycleIconProps> = ({
  className = "text-white",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M20 11.0036C19.7554 9.24383 18.9391 7.61327 17.6766 6.36311C16.4142 5.11294 14.7758 4.31253 13.0137 4.08517C11.2516 3.8578 9.46362 4.21609 7.9252 5.10486C6.38678 5.99362 5.18325 7.36355 4.5 9.00361M4 5.00361V9.00361H8"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path
      d="M4 13.0039C4.24456 14.7637 5.06093 16.3942 6.32336 17.6444C7.58579 18.8946 9.22424 19.695 10.9863 19.9224C12.7484 20.1497 14.5364 19.7914 16.0748 18.9027C17.6132 18.0139 18.8168 16.644 19.5 15.0039M20 19.0039V15.0039H16"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path
      d="M12 9.00391V12.0039"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path
      d="M12 15.0039H12.01"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
  </svg>
)
